import AuthService from '@/services/auth.service';

export const authGuard = (to, from, next) => {
  const isAuthenticated = AuthService.isAuthenticated();
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Not authenticated, redirect to login
      next({
        path: '/authentication/boxedlogin',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    // If user is authenticated and tries to access guest pages (login), redirect to dashboard
    if (isAuthenticated) {
      next('/dashboard/classic-dashboard');
    } else {
      next();
    }
  } else {
    next();
  }
};

export const guestGuard = (to, from, next) => {
  const isAuthenticated = AuthService.isAuthenticated();
  
  if (isAuthenticated) {
    next('/dashboard/classic-dashboard');
  } else {
    next();
  }
};
